// import reviewSaga from './reviews/reviewSaga';
import passwordSaga from './password/passwordSaga';
import accountSaga from './accounts/accountSaga';
import transactionSaga from './transactions/transactionSaga';


export default [passwordSaga, accountSaga, transactionSaga];
